import { defineMessages } from 'react-intl';

export default defineMessages({
    // add string ids and default values for localization here
});
